import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../config/config';
import { AssetMeterPrice } from '../models/assetMeterPrice.model';

@Injectable({
  providedIn: 'root',
})
export class AssetMeterPriceService {
  private pathApi = this.config.setting['pathApi'] + 'assetMeterPrice/';

  constructor(private http: HttpClient, private config: AppConfig) {}

  public getAll(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, dataIn, { observe: 'response' });
  }

  public save(dataIn: AssetMeterPrice): Observable<any> {
    return this.http.post(`${this.pathApi}save`, dataIn, { observe: 'response' });
  }

  public delete(id: number): Observable<any> {
    return this.http.delete(`${this.pathApi}delete/${id}`, { observe: 'response' });
  }
}
